import {OMC_ENTITY} from "../constants";

const getPrettyOMCEntity = (omcEntity) => OMC_ENTITY[omcEntity]?.textValue || omcEntity;

export default getPrettyOMCEntity;
